export const API_BASE_PATH = location.host.includes("local.cisco.com") ? "http://localhost:9002/clientaccessmanager" : `${location.protocol}//${location.host}/auth/clientaccessmanager`;
//export const API_BASE_PATH = location.host.includes("local.cisco.com") ? "https://it-developer-nprd-dev.cisco.com/auth/clientaccessmanager" : `${location.protocol}//${location.host}/auth/clientaccessmanager`;
export const API_PATHS = {
    ACCESS_PAGE_API: `${API_BASE_PATH}/accessRequests`,
    PENDING_REQUESTS: `${API_BASE_PATH}/accessRequests/has_pending_approval`,
    GET_SITES_API: `${API_BASE_PATH}/publishing-details/getSites`,
    ACCESS_SITES_API: `${API_BASE_PATH}/accessRequests/sites`,
}

export const API_PATHS_SITES = {
    SITE_PAGE_API: `${API_BASE_PATH}/publishing-details`,
    GET_SITES_API: `${API_BASE_PATH}/publishing-details/getSites`,
    APPROVE_DENY_API: `${API_BASE_PATH}/publishing-details/approvals`
}
